//{}で動的に記事を作るのは「File System Route API」と呼ぶ
//各BLOG記事１枚分のページ
//mui v5 完了

import React from "react"
import { graphql, Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";
import { kebabCase } from 'lodash/string';

//components
import Layout from "../components/layout"


import DrawerRight from '../components/drawer-right.js'
import Share from '../components/share.js'
import TagBox from '../components/tag-box.js'
import Seo from '../components/seo-head'

//広告
import ArticleAds from '../components/ads/article-ads.js'
// import MobileAds from '../components/ads/mobile-ads.js'
import DrawerRightAds from '../components/ads/drawer-right-ads.js'

//mui v5
import { Breadcrumbs, Paper, Container, Typography, Box, Divider, Link as Link2 } from '@mui/material'
import { useTheme } from '@mui/material/styles'

//table
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, } from '@mui/material'

//アコーディオン(関連記事用)
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';

import useMediaQuery from '@mui/material/useMediaQuery';

const BlogPost = ({ data, location }) => {

  //LCP削減 小さい画面で右ドロワ削除
  //display noneを使わないようにしてみる
  // drawer-right, right-adsのuseMediaQueryなどでdisplay noneを削除してテストすること
  const isMobileSize = useMediaQuery((theme) =>
    theme.breakpoints.down('right_ads'), { noSsr: true }
  )

  const theme = useTheme()

  // const drawerWidthRightAds = "500px";
  const rootPath = `${__PATH_PREFIX__}/`
  // const siteTitle = data.site.siteMetadata?.title || `Title`
  const postTitle = data.markdownRemark.frontmatter.title
  const tags = data.markdownRemark.frontmatter.tags
  const postDate = data.markdownRemark.frontmatter.date
  const postUpdate = data.markdownRemark.frontmatter.update
  const isUpdate = postUpdate && (kebabCase(postUpdate) !== `invalid-date`)
  const postDescription = data.markdownRemark.frontmatter.description
  //プライバシーポリシーなど、画像のないポストがエラーになるので回避
  const postImage = data.markdownRemark.frontmatter.featuredimage ? data.markdownRemark.frontmatter.featuredimage.childImageSharp.gatsbyImageData : null
  const postHtml = data.markdownRemark.html

  //バージョンテーブル用
  const versions = data.markdownRemark.frontmatter.versions
  const rows = versions?.map((v) => {
    return { name: v[0], version: v[1], comment: v[2] }
  })

  //カテゴリ関連
  const selected_category = {
    "parent_category_id": data.markdownRemark.fields.parent_category_id,
    "child_category_id": data.markdownRemark.frontmatter.category_id
  }
  const slug = data.markdownRemark.fields.slug

  // const isEng = data.markdownRemark.fields
  const authorId = data.markdownRemark.frontmatter.author
  const current_category = data.markdownRemark.fields.parent_category
  const parent_category = data.markdownRemark.fields.parent_category_id
  const current_sub_category = data.markdownRemark.fields.child_category
  const toc_html = data.markdownRemark.tableOfContents

  //シリーズ記事一覧
  const series = data.markdownRemark.seriesPosts.map((s) => {
    return { date: s.frontmatter.date, title: s.frontmatter.title, slug: s.fields.slug }
  }).sort((a, b) => {
    // 記事の順番がバラバラになるので日付でソート
    if (a.date > b.date) { return 1 } else { return -1 }
  })
  const seriesTag = data.markdownRemark.frontmatter.seriesTag

  //アコーディオンをデフォルトで折りたたむかドウか
  const accordionDefaultExpanded = series.length < 5 ? true : false

  // style
  const ImgBorderRadius = "20px"
  const styleBlogPostMd = {
    //autolink-headers： hrefが#のページ内リンク
    ".yomitobashi": {
      position: "relative",
      margin: "2em 0",
      padding: "0.5em 2em",
      border: "dotted 2px " + theme.palette.hosoku.default,
      borderRadius: "12px",
      "& ul": {
        //入れ子したときにボーダーがでてくるので削除
        border: "0px",
        padding: "0.5rem",
        margin: "0px 0px 0px 0px",
      },
    },
    ".yomitobashi::before": {
      content: `"読み飛ばしOK"`,
      position: "absolute",
      display: "inline-block",
      top: "-13px",
      left: "10px",
      padding: "0 9px",
      lineHeight: "1",
      background: theme.palette.background.default,
      color: theme.palette.hosoku.default,
      fontWeight: "bold",
    },

    //hosoku
    ".hosoku": {
      position: "relative",
      border: "dashed 1px " + theme.palette.hosoku.secondary,
      borderRadius: "12px",
      margin: "2em 0",
      padding: "0.5em 2em",
      display: "block",
    },
    ".hosoku::before": {
      content: `"NOTE"`,
      position: "absolute",
      display: "inline-block",
      top: "-13px",
      left: "10px",
      padding: "4px 9px",
      lineHeight: "1",
      background: theme.palette.background.default,
      color: theme.palette.hosoku.secondary,
      fontWeight: "bold"
    },

    ".hosoku.koushin::before": {
      content: `"更新"`,
    },
    ".hosoku.tuiki::before": {
      content: `"追記"`,
    },

    "& a.autolinkHeaders": {
      fill: "white",
      height: "100%",
      display: "inline-block",
      justifyContent: "center",
      alignItems: "center",
      marginLeft: "0.5rem"
    },
    "& a": {
      color: "#64b5f6",
      "&:hover": {
        color: "#83c3f7",
      },
      "&:visited": {
        color: "#467eac",
      },
    },
    "& ol": {
      border: "hidden " + theme.palette.background.listBorder,
      backgroundColor: theme.palette.background.listBack,
      padding: "2rem",
      margin: "20px auto",
      borderRadius: "0",
    },
    "& ul": {
      border: "hidden " + theme.palette.background.listBorder,
      backgroundColor: theme.palette.background.listBack,
      padding: "2rem",
      margin: "20px auto",
      borderRadius: "0",
      "& li": {
        "& ul": {
          //入れ子したときにボーダーがでてくるので削除
          border: "0px",
          padding: "0.5rem",
          margin: "0px 0px 0px 0px",
        }
      }
    },
    "& li": {
      padding: "0.3rem",
      marginLeft: "20px",
      paddingLeft: "20px",
      "& code": {
        backgroundColor: theme.palette.background.code,
      },
    },
    "& blockquote": {
      display: "block",
      backgroundColor: theme.palette.background.quotation,
      padding: "15px 20px 15px 45px",
      margin: "0 0 10px",
      position: "relative",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.14)",
      overflowX: "auto",
    },

    "& h1": {
      marginTop: "2rem",
      padding: "1rem 2rem",
      borderLeft: "10px solid",
      borderRadius: "10px",
      borderColor: theme.palette.secondary.main,
      background: theme.palette.background.paper,
      "& code": {
        backgroundColor: theme.palette.background.code,
      },
    },
    "& h2": {
      padding: "0.5rem 0.5rem",
      borderBottom: "2px solid",
      borderColor: theme.palette.secondary.sub,
    },
    "& h3": {
      padding: "0rem 1rem",
      borderLeft: "5px solid",
      borderColor: theme.palette.secondary.sub,
    },
    //テーブル
    "& table": {
      borderCollapse: "collapse",
      border: "solid 2px" + theme.palette.hosoku.secondary,
      tableLayout: "fixed",
      width: "100%"
    },
    "& table th": {
      border: "dashed 1px" + theme.palette.background.tableBorder,
      padding: theme.spacing(2),
      backgroundColor: theme.palette.background.paper,
    },
    "& table td": {
      border: "dashed 1px" + theme.palette.background.tableBorder,
      padding: theme.spacing(1),
    },
    //蛍光ペン
    "& strong": {
      background: "linear-gradient(transparent 80%, " + theme.palette.secondary.mainDark + " 80%)"
    },
    //videoタグ
    "& video": {
      display: "block",
      height: "auto",
      maxHeight: "500px",
    }
  }

  //レイアウトへ渡す
  return (
    <Layout selected_category={selected_category} >

      <Box sx={{
        [theme.breakpoints.up('xl')]: {
          // marginRight: drawerWidthRightAds
          marginRight: "25%"
        },
        [theme.breakpoints.down('md')]: {
          marginRight: 0,
        },
      }}>
        <Container
          maxWidth="md"
        >

          {/* カテゴリ表示 */}
          <Paper sx={{
            marginBottom: theme.spacing(2),
            padding: theme.spacing(1),
            paddingLeft: theme.spacing(2),
          }} variant="outlined">
            <Breadcrumbs aria-label="breadcrumb" separator="›">
              <Link2 color="inherit" component={Link} to={rootPath} >Top</Link2>
              <Link2 color="inherit" component={Link} to={"/category/" + parent_category} >
                {current_category}
              </Link2>
              <Link2 color="inherit" component={Link} to={"/category/" + selected_category.child_category_id} >
                {current_sub_category}
              </Link2>
            </Breadcrumbs>
          </Paper>

          <Box pb={1} pt={1}>
            {isUpdate ?
              <Typography variant="overline">{postUpdate}(更新)</Typography>
              :
              <Typography variant="overline">{postDate}</Typography>
            }
            <Box pb={1}>
              {/* タイトル */}
              <Typography variant="h4" component="h1" sx={{
                fontWeight: 'bold',
                display: "flex",
                alignItems: "center",
                textShadow: "1px 2px 3px black"
              }}>{postTitle}</Typography>
            </Box>
            {/* デスクリプション */}
            {postDescription && <Typography component="h2" variant="subtitle2">{postDescription}</Typography>}
          </Box>

          {/* 記事の画像 */}
          <Box pb={1} pt={1} >
            <GatsbyImage alt="Article Image" image={postImage} style={{
              borderRadius: ImgBorderRadius,
              border: 0
            }} />
          </Box>


          {/* 上部用簡易シェア(ポリシー等でも表示されてしまうので画像があるときのみ) */}
          {postImage &&
            <Share lightVer={true} slug={slug} postTitle={postTitle} authorId={authorId} />
          }

          {/* モバイル向け広告 */}
          {/* 広告統一のためこちらは確実に表示 */}
          {/* {isMobileSize && 
          <>
            <MobileAds />
          </>
          } */}

          <ArticleAds />

          {/* バージョンテーブル */}
          {rows?.length > 0 &&
            <TableContainer>
              <Table aria-label="バージョン表" size="small" >
                <TableHead>
                  <TableRow>
                    <TableCell>使用ソフトウェア</TableCell>
                    <TableCell align="right">バージョン</TableCell>
                    <TableCell align="right">備考</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row, index) => (
                    <TableRow
                      key={row.name + index}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {row.name}
                      </TableCell>
                      <TableCell align="right">{row.version}</TableCell>
                      <TableCell align="right">{row.comment}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          }

          {/* 関連記事用 */}
          {series.length > 0 &&
            <Box pb={1} pt={2} >
              <Accordion square={true}
                defaultExpanded={accordionDefaultExpanded}
                sx={{
                  marginTop: "2rem",
                  padding: "1rem",
                  borderLeft: "10px solid",
                  borderRadius: "10px",
                  borderColor: theme.palette.primary.main,
                  background: theme.palette.background.paper,
                  '&:not(:last-child)': {
                    borderBottom: 0,
                  },
                  '&:before': {
                    display: 'none',
                  },
                  '& .MuiSvgIcon-root': {
                    color: theme.palette.text.primary
                  },
                }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  sx={{
                    '&:hover': {
                      backgroundColor: theme.palette.background.default,
                    },
                    borderRadius: "30px",
                  }}
                >
                  <ArticleOutlinedIcon sx={{ marginRight: theme.spacing(1) }} />
                  <Typography>このシリーズの記事一覧 (クリックで開閉)</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{
                  "& a": {
                    color: "white",
                    "&:hover": {
                      color: "#64b5f6",
                    },
                  },
                }}>
                  <Typography>【 {seriesTag} 】</Typography>
                  <ul>
                    {series.map((s) => (
                      <li key={s.slug}>
                        <Link2 color="inherit" component={Link} to={s.slug} >
                          {s.title}
                        </Link2>
                      </li>
                    ))}
                  </ul>
                  <Box display="flex" justifyContent="flex-end">
                    <DoubleArrowIcon sx={{ marginRight: theme.spacing(1) }} />
                    <Link to={"/tag/" + kebabCase(seriesTag)}>一覧をサムネイル付きインデックスで見る</Link>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </Box>
          }

          {/* 記事本体 */}
          <Box sx={styleBlogPostMd}
            dangerouslySetInnerHTML={{ __html: postHtml }}
          />

          <Divider sx={{ m: theme.spacing(2) }} />

          {/* モバイル向け広告 一時オフ*/}
          {/* {isMobileSize &&
            <>
              <MobileAds />
            </>
          } */}
          <ArticleAds />

          <Divider sx={{ m: theme.spacing(2) }} />

          {/* タグボックス */}
          <TagBox tags={tags} series={series} seriesTag={seriesTag} />

          {/* シェア */}
          <Share slug={slug} postTitle={postTitle} authorId={authorId} />

          <Divider sx={{ m: theme.spacing(3) }} />

          <Typography variant="subtitle2" component="div" sx={{
            flexGrow: 1,
            textAlign: "center"
          }}>謎の技術研究部 (謎技研)</Typography>


          {/* 右側のドロワ*/}
          {isMobileSize !== true &&
            <>
              <DrawerRightAds location={location} />
            </>
          }

          <Box sx={{
            display: "none",
            [theme.breakpoints.up('xl')]: {
              display: "flex",
            },
          }}>
            <DrawerRight toc_html={toc_html} />
          </Box>

        </Container>
      </Box >
    </Layout >
  );
}

export default BlogPost

//Gatsby Head API
export const Head = ({ data, location }) => {

  //ハードコードでnoIndex指定(注意：クォーテーションで文字列にしないこと)
  const noIndex = false //基本はfalse

  const postTitle = data.markdownRemark?.frontmatter.title || ""
  const postDescription = data.markdownRemark?.frontmatter.description || ""
  const postDate = data.markdownRemark?.frontmatter.date || ""
  const postUpdate = data.markdownRemark?.frontmatter.update || ""
  const imagePath = data.markdownRemark?.frontmatter.featuredimage?.childImageSharp?.gatsbyImageData?.images?.fallback?.src || ""
  const authorId = data.markdownRemark?.frontmatter.author || ""

  return (
    <Seo
      title={postTitle}
      description={postDescription}
      postDate={postDate}
      postUpdate={postUpdate}
      imagePath={imagePath}
      twitter={authorId}
      location={location}
      noIndex={noIndex}
    />
  )
}


// File System Route APIによる呼び出し
export const pageQuery = graphql`query BlogPostBySlug($id: String!, $previousPostId: String, $nextPostId: String) {
  site {
    siteMetadata {
            title
          }
        }
        markdownRemark(id: { eq: $id }) {
          id
          excerpt(pruneLength: 160)
          html
    headings {
            depth
            value
          }
          tableOfContents(maxDepth: 2)
    fields {
            parent_category
            child_category
            parent_category_id
            slug
            isEng
          }
    seriesPosts {
      frontmatter { title, date }
      fields { slug }
    }
    frontmatter {
            title
            date(formatString: "YYYY-MM-DD")
            update(formatString: "YYYY-MM-DD")
            description
            category_id
            author
            tags
            versions
            seriesTag
      featuredimage {
        childImageSharp {
                gatsbyImageData(
                  width: 960,
                  placeholder: BLURRED,
                  quality: 70,
                  layout: CONSTRAINED,
                  formats:[AUTO, WEBP, AVIF]
                )
              }
            }
          }
        }
        previous: markdownRemark(id: { eq: $previousPostId }) {
    fields {
            slug
          }
    frontmatter {
            title
          }
        }
        next: markdownRemark(id: { eq: $nextPostId }) {
    fields {
            slug
          }
    frontmatter {
            title
          }
        }
      }
`
